import React from "react";
import {createListFromArray, createListFromArrayOfObjects} from "../../../../Utilities/Types/listUtilities";
import {Button, convertInputFormToObject, InputForm, inputStyles, useInputForm} from "../../../../Components/Inputs";
import {clearInputFormFields} from "../../../../Components/Inputs/inputUtility";
import {GridCell, gridConstants, GridContainer} from "../../../../Components/Grid";
import {SearchableSingleSelectField} from "../../../../Components/Inputs/SearchableSingleSelectField";

interface AphLoanSearchFormViewProps {
    aphLoanSearchCriteria: Record<string, any>;
    aphLoanSearchDropDowns: Record<string, any>;
    handleSetAphLoanSearchCriteria: (criteria: Record<string, any>) => void;
    isLoading: boolean;
}

export const AphLoanSearchFormView = ({
                                          aphLoanSearchCriteria,
                                          aphLoanSearchDropDowns,
                                          handleSetAphLoanSearchCriteria,
                                          isLoading,
                                      }: AphLoanSearchFormViewProps) => {

    const searchForm = useInputForm(aphLoanSearchCriteria);

    const patrons = createListFromArrayOfObjects(aphLoanSearchDropDowns.patrons, "userId", "fullName");
    const shippingLocations = createListFromArrayOfObjects(aphLoanSearchDropDowns.shippingLocations, "shippingLocationId", "name");
    const students = createListFromArrayOfObjects(aphLoanSearchDropDowns.students, "studentId", "fullName");
    const districts = createListFromArrayOfObjects(aphLoanSearchDropDowns.districts, "districtId", "districtName");
    const organizations = createListFromArray(aphLoanSearchDropDowns?.organizations);

    const handleClearClick = () => {
        clearInputFormFields(searchForm);
        const updatedLoanSearchCriteria = {...aphLoanSearchCriteria};
        updatedLoanSearchCriteria.ClearOrderSearch();
    };

    const handleSearchClick = () => {
        let criteria = convertInputFormToObject(searchForm);
        const updatedLoanSearchCriteria = {...aphLoanSearchCriteria};
        updatedLoanSearchCriteria.Search(criteria);
        handleSetAphLoanSearchCriteria(updatedLoanSearchCriteria);
    };

    const inputSharedSettings = {
        medium_columns: gridConstants.column.FOUR,
    };

    return <>
        <InputForm name={"loanSearch"} hasPaddingY>

            <SearchableSingleSelectField
                {...searchForm.patronId}
                {...inputSharedSettings}
                includeDefaultOption
                label={'Patron'}
                options={patrons}
            />

            <SearchableSingleSelectField
                {...searchForm.shippingLocationId}
                {...inputSharedSettings}
                includeDefaultOption
                label={'Shipping Locations'}
                options={shippingLocations}
            />

            <SearchableSingleSelectField
                {...searchForm.studentId}
                {...inputSharedSettings}
                includeDefaultOption
                label={'Student'}
                options={students}
            />

            <SearchableSingleSelectField
                {...searchForm.districtId}
                {...inputSharedSettings}
                includeDefaultOption
                label={'District'}
                options={districts}
            />

            <SearchableSingleSelectField
                {...searchForm.organization}
                {...inputSharedSettings}
                includeDefaultOption
                label={'Organization'}
                options={organizations}
            />

            <GridCell>
                <GridContainer hasPaddingX isFlush isReverseOrder>

                    <GridCell medium_columns={gridConstants.column.FOUR}>
                        <Button
                            buttonType={inputStyles.button.types.SEARCH}
                            disabled={isLoading}
                            label="Search"
                            name="btnSearchLoan"
                            onClick={handleSearchClick}
                            isPrimary
                        />
                    </GridCell>

                    <GridCell medium_columns={gridConstants.column.FOUR}>
                        <Button
                            buttonType={inputStyles.button.types.CLEAR}
                            disabled={isLoading}
                            name="btnClearLoanSearch"
                            onClick={handleClearClick}
                            label="Clear"
                        />
                    </GridCell>

                </GridContainer>
            </GridCell>

        </InputForm>
    </>;
};